import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import TextGradient from "@app/components/gradient/gradient-text"
import { useState } from "react";

const MobileManufacturingProcessing = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="pt-4 px-8 pb-8">
      <div>
        <div className="flex flex-col space-y-5 ">
          <TextGradient>
            <span className="h2">02</span>
          </TextGradient>
          <p className="mobile-h3 2xs:mobile-h2 text-background-primary-dark">
            Manufacturing & Food Processing
          </p>
          <GradientContainer overrideClassName="w-[30%] h-2" />
          <div className="text-text-color-mid-em-light space-y-5">
            <p>
              SimpleWaste represents all sectors of the manufacturing industry.
            </p>
            <p>
              Our unique service and technology platform are ideal for retail, storefronts, grocery, and convenience stores!
              Your various waste and recycling profiles are seamlessly managed through our technology portal.
            </p>
            {isExpanded &&
              <div className="space-y-5">
                <p>
                  At SimpleWaste we design effective solutions that flow seamlessly within
                  your operational footprint. Waste stream management and equipment
                  optimization are essential for collecting and handling the unique
                  waste profiles generated from the industry.
                </p>
              </div>
            }
          </div>
          <div>
            <Button onClick={() => setIsExpanded(!isExpanded)}>
              {isExpanded ? 'Read less' : 'Read more'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileManufacturingProcessing;